module.exports = __webpack_public_path__ + "static/img/wenzi.ceed9b31.png";